module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_ltv-3d9aec90f5aaec7a087aec1d8bef9f88.svg";